// The card's element, for the two things that want it (PLAN-UI §28.3, U6).

import { useCallback, useState } from "react";

import { useChromeRect } from "../kit";

/**
 * Register a selection card and hand back the element its hover cards anchor
 * beside.
 *
 * **`edge: null`**: the card appears and vanishes with a selection, and an edge
 * the camera backs away from would pan the board on every click. The element is
 * kept in *state* as well because the hover cards need it during a render
 * (`HoverCard`'s `beside`) and the registry's callback keeps it to itself; one
 * ref chains the two.
 *
 * One rect id for every card, because only one of them is ever mounted.
 */
export function useCardBox(): {
  root: (node: HTMLElement | null) => void;
  box: HTMLElement | null;
} {
  const measure = useChromeRect("inspector", null);
  const [box, setBox] = useState<HTMLElement | null>(null);
  const root = useCallback(
    (node: HTMLElement | null) => {
      measure(node);
      setBox(node);
    },
    [measure]
  );
  return { root, box };
}
